export class ApiError extends Error {
  readonly method: string;
  readonly path: string;
  readonly code: string;
  readonly status?: number;

  constructor(method: string, path: string, code: string, message: string, status?: number) {
    super(`${method} ${path} failed (${code}): ${message}`);
    this.name = "ApiError";
    this.method = method;
    this.path = path;
    this.code = code;
    this.status = status;
  }
}

export function parseApiError(method: string, path: string, status: number, body: string): never {
  try {
    const parsed = JSON.parse(body) as { error?: { code?: string; message?: string } };
    const error = parsed.error;
    if (error != null && typeof error === "object") {
      const code = error.code ?? "UNKNOWN";
      const message = error.message ?? body;
      throw new ApiError(method, path, String(code), String(message), status);
    }
  } catch (error) {
    if (error instanceof ApiError) {
      throw error;
    }
  }

  throw new ApiError(method, path, "UNKNOWN", body, status);
}
